import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#004680',
      dark: '#003560',
      light: '#3377aa'
    },
    secondary: {
      main: '#32324E'
    },
    error: {
      main: '#F44336'
    },
    warning: {
      main: '#FF9800'
    },
    success: {
      main: '#4CAF50'
    },
    text: {
      primary: '#32324E',
      secondary: '#6E6E80'
    },
    background: {
      default: '#FFFFFF',
      paper: '#F5F5F5'
    },
    DataGrid: {
      headerBg: '#004680'
    }
  },
  typography: {
    fontFamily: "'Poppins', sans-serif"
  },
  components: {
    MuiTextField: {
      defaultProps: {
        size: 'small',
        variant: 'outlined'
      },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#F5F5F5',
            borderRadius: 6,
            '& fieldset': {
              borderColor: '#E0E0E0'
            },
            '&:hover fieldset': {
              borderColor: '#004680'
            },
            '&.Mui-focused fieldset': {
              borderColor: '#004680',
              boxShadow: '0 0 0 2px rgba(0, 70, 128, 0.15)'
            }
          }
        }
      }
    },
    MuiSelect: {
      defaultProps: {
        size: 'small'
      },
      styleOverrides: {
        root: {
          backgroundColor: '#F5F5F5',
          borderRadius: 6,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E0E0E0'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#004680'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#004680'
          }
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          border: 'none',
          borderRadius: 20
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: 'white',
          color: '#004680',
          textTransform: 'uppercase',
          fontWeight: 600,
          padding: '0.6em 0.9em',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#004680',
            color: 'white',
            border: 'solid 1px #32324e'
          },
          '&:hover': {
            color: '#004680'
          }
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.15)',
          '&.Mui-checked': {
            color: '#004680'
          }
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          '--DataGrid-t-header-background-base': '#004680',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#004680'
          },
          '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#004680',
            color: '#fff'
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            color: '#fff'
          },
          '& .MuiDataGrid-columnHeaderTitleContainer': {
            color: '#fff',
            display: 'flex',
            alignItems: 'center'
          },
          '& .MuiDataGrid-sortIcon': {
            color: '#fff'
          },
          '& .MuiDataGrid-columnHeader .MuiCheckbox-root': {
            color: 'rgba(255,255,255,0.8)',
            '&.Mui-checked': {
              color: '#fff'
            }
          },
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center'
          }
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#32324E'
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#FFFFFF',
          borderRight: '1px solid #E0E0E0'
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '&.Mui-selected': {
            backgroundColor: 'rgba(0, 70, 128, 0.1)',
            color: '#004680',
            '&:hover': {
              backgroundColor: 'rgba(0, 70, 128, 0.18)'
            },
            '& .MuiListItemIcon-root': {
              color: '#004680'
            }
          },
          '&:hover': {
            backgroundColor: 'rgba(0, 70, 128, 0.06)'
          }
        }
      }
    }
  }
})

export default theme
